import { useGetPayoutAccountInfoQuery } from '@graphql/queries/registry.graphql.generated';
import { hasActiveStripeAccount } from '@shared/utils/payoutAccount';
import { DEFAULT_CURRENCY } from '@shared/utils/currency/constants';

export type PayoutCurrencyLockState = Readonly<{
  isCurrencyLocked: boolean;
  lockedCurrencyCode: string | null;
  loading: boolean;
}>;

/** Fetches payout account status independently — safe to use outside CreditCardSetupProvider. */
export const usePayoutCurrencyLock = (eventId: string | undefined, currentCurrencyCode: string | null): PayoutCurrencyLockState => {
  const { data, loading } = useGetPayoutAccountInfoQuery({
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
    skip: !eventId,
    variables: { eventId: eventId! },
  });

  const payoutAccount = data?.getRegistryEventData?.payoutAccount;
  const isCurrencyLocked = !!payoutAccount?.status && hasActiveStripeAccount(payoutAccount.status);
  const lockedCurrencyCode = isCurrencyLocked ? (payoutAccount?.currencyCode ?? currentCurrencyCode ?? DEFAULT_CURRENCY) : null;

  return { isCurrencyLocked, lockedCurrencyCode, loading };
};
